import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9f050d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = { style: {"color":"#333"} }
const _hoisted_3 = { key: 0 }

import {
  ref,
  onMounted,
  withDefaults,
  computed,
  watch,
} from "vue";
import { taxCategoryApplyInfo } from "@/api/process_bank";

export default /*#__PURE__*/_defineComponent({
  props: {
    update: { type: Boolean, default: false },
    folwId: { default: 0 }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { update: boolean, folwId: number }



const taxOptions = [
  "企业所得税",
  "个人所得税",
  "增值税",
  "城市维护建设税",
  "教育费附加",
  "地方教育费附加",
  "残保金",
  "印花税-营业账簿",
  "印花税-租赁合同",
  "其他",
];

watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getTaxCategoryApplyInfo();
    }
  }
);
const detail = ref({
  TaxCategoryList: [],
});
const getTaxCategoryApplyInfo = async () => {
  const { Data } = await taxCategoryApplyInfo({
    BranchCompanyFlowId: Number(props.folwId),
  });
  if (Data?.PageData) {
    detail.value.TaxCategoryList = Data.PageData.TaxCategoryList;
  }
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  getTaxCategoryApplyInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (detail.value.TaxCategoryList.length > 0)
      ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
          key: 0,
          disabled: "",
          value: detail.value.TaxCategoryList
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.TaxCategoryList, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_checkbox, {
                key: index,
                class: _normalizeClass(index == 8 ? 'nomargin' : ''),
                value: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, [
                    _createTextVNode(_toDisplayString(taxOptions[item.Type]), 1),
                    (item.Type == 9)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString("(" + item.Description + ")"), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["class", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})